import NAME from "./constants";

export const getLoading = store => store[NAME].loading;
export const getAnnexesRows = store => store[NAME].annexes;
export const getInstances = store => store[NAME].instances;
export const getAnnexesTypes = store => store[NAME].annexestypes;
export const getUserDates = store => store[NAME].userDates;
export const getColabModifiableDocuments = store => store[NAME].colabModifiableDocuments;